/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityPage} from '../api'

export const useMutationActivityPage = createReactQueryMutationHook('activityPage', activityPage)
